module["exports"] = [
  "gmail.com",
  "yahoo.com",
  "hotmail.com"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/nl/internet/free_email.js
 ** module id = 890
 ** module chunks = 0
 **/